import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { Grid, Header, List, Segment } from 'semantic-ui-react'
import Contact from 'shared/Contact'

export default function RecentSection() {
    const { contacts, isReadingContacts, leads, isReadingLeads, opportunities, isReadingOpportunities } = useSelector(state => ({
        contacts: state.contacts.recent_contacts?.map(formatContacts()) || [],
        isReadingContacts: state.contacts.isReadingRecentContacts,
        leads: state.leads.leads?.map(formatRecords()) || [],
        isReadingLeads: state.leads.isReadingLeads,
        opportunities: state.opportunities.opportunities?.map(formatRecords()) || [],
        isReadingOpportunities: state.opportunities.isReadingOpportunities,
    }))
    return (
        <Grid>

            <Grid.Row columns={4}>

                <Grid.Column width={4}>
                    <Segment loading={isReadingContacts}>

                        <Header as='h3' color="primary">
                            Recent Contacts
                        </Header>
                        {
                            contacts.map((contact) => <List key={contact.id}>
                                <Contact
                                    contact={{ ...contact, phone: contact?.phone }}
                                    name={`${contact.first_name} ${contact.last_name}`}
                                    isSimplified={true}
                                    linkToContact={<Link to={`/contact/${contact.id}`}>{`${contact.first_name} ${contact.last_name}`}</Link>}
                                />
                            </List>)
                        }
                    </Segment>
                </Grid.Column>
                <Grid.Column width={4}>
                    <Segment loading={isReadingLeads}>

                        <Header as='h3' color="primary">
                            Recent Leads
                        </Header>
                        {
                            leads.map((lead) => <List key={lead.id}>
                                <Contact
                                    contact={{ ...lead, phone: lead?.phone, id: lead?.contact_id }}
                                    name={`${lead.first_name} ${lead.last_name}`}
                                    isSimplified={true}
                                    linkToContact={<Link to={`/contact/${lead?.contact_id}`}>{`${lead.first_name} ${lead.last_name}`}</Link>}
                                />
                            </List>)
                        }
                    </Segment>
                </Grid.Column>

                <Grid.Column width={4}>
                    <Segment loading={isReadingOpportunities}>
                        <Header as='h3' color="primary">
                            Recent Opportunities
                        </Header>
                        {
                            opportunities.map((opportunity) => <List key={opportunity.id}>
                                <Contact
                                    contact={{ ...opportunity, phone: opportunity?.phone, id: opportunity?.contact_id }}
                                    name={`${opportunity.first_name} ${opportunity.last_name}`}
                                    isSimplified={true}
                                    linkToContact={<Link to={`/contact/${opportunity?.contact_id}`}>{`${opportunity.first_name} ${opportunity.last_name}`}</Link>}
                                />
                            </List>)
                        }
                    </Segment>
                </Grid.Column>
                <Grid.Column width={4}>

                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
}


function formatRecords() {
    return ({ contact, title, pipeline_id: id, account_type }) => {
        const first_name = contact.first_name || '';
        const last_name = contact.last_name || '';
        const suffix = contact.suffix || '';
        const custom_data = contact.custom_data || { fields: {} };
        return {
            first_name,
            last_name,
            suffix,
            title,
            id,
            custom_data,
            account_type,
            contact_id: contact.id
        };
    };
}

function formatContacts() {
    return contact => {
        let first_name = contact.first_name || '';
        let last_name = contact.last_name || '';
        let suffix = contact.suffix || '';
        if (first_name === '' && last_name === '') {
            [first_name, last_name] = contact.account_name ? contact.account_name.split(' ') : ['Unknown', 'Name'];
        }
        return {
            ...contact,
            account_type: contact.contact_type,
            contact_id: contact.id,
            account_id: contact.account ? contact.account.id : 0,
            first_name,
            last_name,
            suffix,
        }
    }
}
